import { useMemo } from 'react'
import { useTheme } from '@iqueue/ui-kit'
import { Line } from 'react-chartjs-2'
import { times, always } from 'ramda'
import ProductionDiffLine from '../ProductionDiffLine'
import { measurementToTitle } from '../Measurement'

const labels = times(always(''), 24)

export default function HourlyProductionChart({
  hourlyData,
  extraData,
  subtitle,
  unit = 'volume',
  currentHourValue = 0,
  pastHourValue = 0,
}) {
  const { getCSSValue } = useTheme()

  const data = useMemo(() => {
    return {
      labels,
      datasets: extraData ? [{
        data: hourlyData,
        pointStyle: false,
        borderColor: getCSSValue('--iq-success'),
        borderWidth: 2,
        tension: 0.15,
      }, {
        data: extraData,
        pointStyle: false,
        borderColor: getCSSValue('--iq-accent-secondary'),
        borderWidth: 1,
        tension: 0.15,
      }] : [{
        data: hourlyData,
        pointStyle: false,
        borderColor: getCSSValue('--iq-success'),
        borderWidth: 2,
        tension: 0.15,
      }],
    }
  }, [hourlyData, extraData, getCSSValue])

  const options = useMemo(() => {
    // noinspection JSUnusedGlobalSymbols
    return {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 0,
      },
      scales: {
        x: {
          display: false,
        }, y: {
          display: true,
          position: 'right',
          border: {
            display: false,
          }, grid: {
            color: getCSSValue('--iq-darken'),
          }, ticks: {
            beginAtZero: true,
            color: getCSSValue('--iq-color'),
            callback: (value) => measurementToTitle(value, unit),
          },
        },
      },
      plugins: {
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
        },
      },
    }
  }, [getCSSValue])

  return <div className={ 'chart-hourly-production' }>
    {/*<h3>Title</h3>*/}
    { !!subtitle && <p>{ subtitle }</p> }

    <div className={ 'chart' }>
      <Line data={ data } options={ options } />

      <ProductionDiffLine
        percentage={ false }
        current={ currentHourValue }
        // currentPostfix={ '/' + t('time.per.hour') }
        past={ pastHourValue }
        unit={ unit }
      />
    </div>
  </div>
}
